module.exports = __webpack_public_path__ + "static/img/81c230ef7458d1a3f62d67dadac902f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品与服务-改(1)_03.jpg
// module id = +LhM
// module chunks = 1